import { useEffect, useState } from "react";
import axios from "axios";
import subscribeBody from "./SubscribeRequest";
import LoadingScreen from "./LoadingScreen"
import StoreNumber from "./data/storeNumberData";
import storeData from "./data/storeData.json";



const SubscribeFormPrefilled = () => {

    //http://connect-preference-api-dev.ds03.internal.tekside.io
    const lock = 0;
    const [enableForm, setEnableForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alreadySub, setAlreadySub] = useState(false);
    const [showSubscribeMessage, setshowSubscribeMessage] = useState(false);

    //User fields
    const [email, setEmail] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [province, setProvince] = useState("default");
    const [store, setStore] = useState("default");
    const [storeNumber, setStoreNumber] = useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [bday, setBirthday] = useState("");
    const [groceries, setGroceries] = useState(false);
    const [genMerch, setGenMerch] = useState(false);
    const [homeFurn, setHomeFurn] = useState(false);
    const [motorsports, setMotorsports] = useState(false);
    const [recipes, setRecipes] = useState(false);
    const [contests, setContests] = useState(false);
    const [toys, setToys] = useState(false);

    const year = new Date().getFullYear();

    /******************** Permanent functions don't change between projects ********************/

    /**
     * On page load parses the id from the URL and verifies the token. 
     * If the token is valid the email is used to retrieve the contact information
     */
    useEffect(() => {
        // eslint-disable-next-line no-restricted-globals
        let params = new URLSearchParams(location.search);
        const email = params.get("email");
        if(email !== "") {
            setEnableForm(true);
            getContact(email);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lock])

    /**
     * Set's the contactData state with the information returned from doing a GET req with the users email, if they exist. If the user 
     * does not exist a message will be shown to the user informing them to fill out the fields and create their account.
     * @param  {[string]} email A string containing the users email.
     * @return {[void]} Returns nothing.
     */
     const getContact = (email) => {
        setEmail(email);
        const axiosConfig = { 
            headers : {
                appID: '$X5$W&&3hwZ$qQx+A3VT#dYWLV'
            }
        }
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/subscribe?email=${email}`, axiosConfig)
        .then(response => {
            if(response.status === 200) {
                setLoading(false);
                populateFields(response.data.content);
            } else {
                console.log(response.status)
                console.log(response)
                console.log("Something went wrong with getting the contact.");
            }
        });
    }

    /**
     * Used to check the validity of the email.
     * @param {String} email Passed in from the email input.
     * @returns True if the email is of vliad form, false otherwise.
     */
     function validateEmail(email){
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //return the opposite
        return !re.test(String(email).toLowerCase()); 
    }

    /**
     * Sends a post to the API with the information gathered from the fields the user has entered.
     * @param {event} event User presses subscribe button 
     */
    const handleContactRequest = async (event) => {
        event.preventDefault();
        if (validateForm()){
            setLoading(true);
            const sendBody = subscribeBody;
            const axiosConfig = {
                headers: {
                    appid: "$X5$W&&3hwZ$qQx+A3VT#dYWLV"
                },
            };
            updateSendBody(sendBody);
            sendBody.email = email;

            try {
                axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/contact`,
                    sendBody,
                    axiosConfig
                ).then(response => {
                    //User was not subscribed to the service
                    console.log("User subscribed" + response.content);
                    setLoading(false);
                    setshowSubscribeMessage(true);
                }).catch((error) => {
                    //User is already subscribed to the service
                    console.log(error);
                    console.log(error.message);
                    console.log(error.response);
                    setLoading(false);
                    setAlreadySub(true);
                });
                
            } catch (error) { 
                console.error(error);
            }
        }
    };

    /********************************************************************************/

    /**
     * Set's all the hooks that contain field information with the data received from the GET req
     * @param  {[Array]} data A JSON object containing all the contact information recieved from the GET req
     */ 
    const populateFields = (data) => {
        if (data.length > 0) {
            var rawFields = JSON.parse(JSON.stringify(data[0].fields));
            setFirstname(rawFields["First Name"]);
            setLastname(rawFields["Last Name"]);
            populateStoreSelect(rawFields.Province, rawFields["Store Name"]);
            setPhoneNum(rawFields["Telephone"]);
            setBirthday(new Date(rawFields["Birth Date"]).toISOString().slice(0,10));
            setGroceries(rawFields["Pref_Groceries"] === "Y" ? true : false);
            setGenMerch(rawFields["Pref_General Merchandise"] === "Y" ? true : false);
            setHomeFurn(rawFields["Pref_Home Furniture"] === "Y" ? true : false);
            setContests(rawFields["Pref_Contests"] === "Y" ? true : false);
            setMotorsports(rawFields["Pref_Motorsports"] === "Y" ? true : false);
            setToys(rawFields["Pref_Toys"] === "Y" ? true : false);
            setRecipes(rawFields["Pref_Recipes"] === "Y" ? true : false);
        }
    }

    /**
     * Populates the select for stores based on province selection. Based on the store select 
     * hooks for the store and the store number are set.
     * @param {string} store the store that the user has selected.
     */
     const populateStoreSelect = (prov, stor) => {
        if(prov === "Newfoundland & Labrador") {
            prov = "NewfoundlandandLabrador";
        }

        const selectBox = document.querySelector('#store');
        let storeList = storeData[prov];

        if(prov !== province){
            removeAll(selectBox);
            setStore("default");
            setStoreNumber("");

        }
        setProvince(prov);
        
        let newOption = new Option('Select your store', '');
        newOption.setAttribute('disabled', true);

        selectBox.add(newOption, undefined); 
        
        for(let i = 0; i < storeList.length; i++) {
            let newOption = new Option(storeList[i], storeList[i]);
            selectBox.add(newOption, undefined);
        }

        if(stor) {
            document.querySelector("#store").value = stor;
            setStore(stor);
            setStoreNumber(StoreNumber(stor));
        }
    };

    /**
     * Removes all inner option elements from a select element.
     * @param {select} selectBox The select element.
     */
     function removeAll(selectBox) {
        while (selectBox.options.length > 0) {
            selectBox.remove(0);
        }
    }

    /**
     * Resets any error messages that were created from the user entering invalid input.
     */
    function resetErrors(){
        document.getElementById("emailInput").style.border = "1px #D0CCC7 solid";
        document.getElementById("firstNameInput").style.border = "1px #D0CCC7 solid";
        document.getElementById("lastNameInput").style.border = "1px #D0CCC7 solid";
        document.getElementById("province").style.border = "1px #D0CCC7 solid";
        document.getElementById("store").style.border = "1px #D0CCC7 solid";
        document.getElementById("bdayInput").style.border = "1px #D0CCC7 solid";
        document.getElementById("phoneNumberInput").style.border = "1px #D0CCC7 solid";
        setAlreadySub(false);
    }

    /**
         * Checks whether the form the user has filled out is of valid form.
         * @returns true if the form is valid, false otherwise
         */
    function validateForm() {
        resetErrors();
        var success = true;
        if (email === ""){
            document.getElementById("emailInput").style.border = "1px red solid";
            success = false;
        } else if (validateEmail(email)){
            document.getElementById("emailInput").style.border = "1px red solid";
            success = false;
        } else if (firstname === ""){
            document.getElementById("firstNameInput").style.border = "1px red solid";
            success = false;
        } else if (lastname === ""){
            document.getElementById("lastNameInput").style.border = "1px red solid";
            success = false;
        } else if (province === ""){
            document.getElementById("province").style.border = "1px red solid";
            success = false;
        } else if (store === ""){
            document.getElementById("store").style.border = "1px red solid";
            success = false;
        } else if (phoneNum === "") {
            document.getElementById("phoneNum").style.border = "1px red solid";
            success = false;
        } else if (bday === "") {
            document.getElementById("bday").style.border = "1px red solid";
            success = false;
        }
        return success;
    }

    /**
     * Sets all the values in the body that gets sent to the POST req.
     * @param {Object} sendBody The JS object used in the POST req.
     */
    function updateSendBody(sendBody){
        sendBody.fields[0].value = email;
        sendBody.fields[1].value = firstname;
        sendBody.fields[2].value = lastname;
        if(province === "NewfoundlandandLabrador") {
            sendBody.fields[3].value = "Newfoundland & Labrador";
        } else {
            sendBody.fields[3].value = province;
        }
        sendBody.fields[4].value = store;
        sendBody.fields[5].value = storeNumber;
        sendBody.fields[6].value = phoneNum;
        sendBody.fields[7].value = bday;
        sendBody.fields[8].value = groceries ? "Y" : "N";
        sendBody.fields[9].value = genMerch ? "Y" : "N";
        sendBody.fields[10].value = homeFurn ? "Y" : "N";
        sendBody.fields[11].value = contests ? "Y" : "N";
        sendBody.fields[12].value = motorsports ? "Y" : "N";
        sendBody.fields[13].value = toys ? "Y" : "N";
        sendBody.fields[14].value = recipes ? "Y" : "N";
    }

    return ( 
        <div className="main-container">
            <a href="https://www.northmart.ca/" target="_blank" rel="noreferrer" className="header-container">
                <div className="header-body">
                    <img alt="Logo" src={require("./images/logo_northern.jpg")}/>
                </div>
            </a>
            {enableForm ?
                <>
                    {!showSubscribeMessage ?
                        <div className="body-container">
                            <div className="body-header">
                                <h1>Profile Preferences</h1>
                                <p>Update your profile to get the latest deals and insider news delivered straight to your inbox. Be the first to know about new products, exclusive promotions, and upcoming events. Plus, enjoy flyers tailored just for you, so you’ll always receive the most relevant offers in your community!</p>
                            </div>
                            <form id="contact" name="contact" onSubmit={handleContactRequest} className="form-section">
                                <div className="form-field" id="email">
                                    <label for="emailInput">Email</label>
                                    <input type="text" defaultValue={ email } placeholder="Email (required)" name="email" id="emailInput" onChange={(e) => setEmail(e.target.value)} />                                    
                                </div>
                                <div className="form-field" id="firstName">
                                    <label for="firstNameInput">First Name</label>
                                    <input type="text" defaultValue={ firstname } placeholder="First Name (required)" name="firstNameInput" id="firstNameInput" onChange={(e) => setFirstname(e.target.value)} />
                                </div>
                                <div className="form-field" id="lastName">
                                    <label for="lastNameInput">Last Name</label>
                                    <input type="text" defaultValue={ lastname } placeholder="Last Name (required)" name="lastNameInput" id="lastNameInput" onChange={(e) => setLastname(e.target.value)} />
                                </div>    
                                <div className="form-field">
                                    <label for="province">Province/Territory</label>
                                    <select name="province" id="province" value={province} className="form-select-field" onChange={(e) => populateStoreSelect(e.target.value, null)}>
                                        <option value="default" disabled>Province/Territory (required)</option>
                                        <option value="Alberta">Alberta</option>
                                        <option value="Manitoba">Manitoba</option>
                                        <option value="NewfoundlandandLabrador">Newfoundland and Labrador</option>
                                        <option value="Northwest Territories">Northwest Territories</option>
                                        <option value="Nunavut">Nunavut</option>
                                        <option value="Ontario">Ontario</option>
                                        <option value="Quebec">Quebec</option>
                                        <option value="Saskatchewan">Saskatchewan</option>
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label for="store">Store</label>
                                    <select name="store" id="store" value={store} className="form-select-field" onChange={(e) => {
                                        setStore(e.target.value);
                                        setStoreNumber(StoreNumber(e.target.value));
                                    }}>
                                        <option value="default" disabled>Select your store (required)</option>
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label for="phoneNumberInput">Phone Number</label>
                                    <input type="text" defaultValue={phoneNum} placeholder="Phone Number (required)" name="phoneNumberInput" id="phoneNumberInput" onChange={(e)=> setPhoneNum(e.target.value)} />
                                </div>
                                <div className="form-field">
                                    <label for="bdayInput">Birthday</label>
                                    <input type="date" defaultValue={bday} placeholder="Birthday (required)" name="bdayInput" id="bdayInput" onChange={(e)=> setBirthday(e.target.value)} />
                                </div>
                                <div className="preferences-header">
                                    <div>Preferences</div><div className="preferences-header-subtext">(check all boxes that you would like more information)</div>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={groceries} name="groceriesInput" id="groceriesInput" className="form-field-checkbox" onChange={(e)=> setGroceries(e.target.checked)} />
                                    <label htmlFor="groceriesInput" style={{textAlign:'left'}}>Groceries</label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={genMerch} name="genMerchInput" id="genMerchInput" className="form-field-checkbox" onChange={(e)=> setGenMerch(e.target.checked)} />
                                    <label htmlFor="genMerchInput" style={{textAlign:'left'}}>General Merchandise ( Apparel, Housewares, Toys, etc. ) </label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={homeFurn} ame="homeFurnInput" id="homeFurnInput" className="form-field-checkbox" onChange={(e)=> setHomeFurn(e.target.checked)} />
                                    <label htmlFor="homeFurnInput">Home furnishings</label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={motorsports} ame="motorsportsInput" id="motorsportsInput" className="form-field-checkbox" onChange={(e)=> setMotorsports(e.target.checked)} />
                                    <label htmlFor="motorsportsInput">Motorsports</label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={recipes} ame="recipesInput" id="recipesInput" className="form-field-checkbox" onChange={(e)=> setRecipes(e.target.checked)} />
                                    <label htmlFor="recipesInput">Recipes</label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={contests} ame="contestsInput" id="contestsInput" className="form-field-checkbox" onChange={(e)=> setContests(e.target.checked)} />
                                    <label htmlFor="contestsInput">Contests</label>
                                </div>
                                <div className="form-field-checkbox" style={{marginBottom: '10px'}}>
                                    <input type="checkbox" defaultValue={false} checked={toys} ame="toysInput" id="toysInput" className="form-field-checkbox" onChange={(e)=> setToys(e.target.checked)} />
                                    <label htmlFor="toysInput">Toys</label>
                                </div>
                                <div className="button-field">
                                    <label id="button-label" htmlFor="submit" className="form-field-label"></label>
                                    <button type="submit" className="button-submit">SUBMIT</button>
                                    {loading && <LoadingScreen/>}
                                    {alreadySub && <div className="text-header-large">No changes we're made to your information.</div>}
                                </div>
                            </form>
                            <br />
                            
                        </div>
                    :
                        <div className="body-container">
                            <div className="text-header-large">{"Your contact information has been updated."}</div>
                        </div>
                    }
                    </>
            :
                <LoadingScreen/>
            }
            <div className="footer-container">
                <div className="footer-body">
                    <p>You may withdraw your consent at any time. Please refer to our <a className="footer-legal-links" href="https://www.northmart.ca/legal-privacy">Privacy Policy</a> or <a className="footer-legal-links" href="https://www.northmart.ca/contact-us">Contact Us</a> for more details.</p>
                    <img className="footer-logo" alt="North West Logo" src={require("./images/logoBottom.jpg")}/>
                </div>
                <div className="footer-legal">
                    The North West Company 77 Main Street Winnipeg, MB Canada R3C 1A3 (204) 943-0881
                    <br></br>
                    <br></br>
                    © {year} The North West Company
                </div>
            </div>
        </div>
     );
}
 
export default SubscribeFormPrefilled; 